import React, { useId, useState } from 'react'
import { Link } from 'react-router-dom'
import VisuallyHidden from '../../lib/a11y/VisuallyHidden'
import { LABELS } from '../constants/staticText'

// Bereiche der Messe in der Sidebar der Abschnittsseiten (Spec-Aenderung
// 2026-09-30, vorher Tab-Leiste #111): alle Kacheln als senkrechte Liste in
// kuratierter Reihenfolge — derselbe joinWpTiles-Stand wie das Kachelraster.
// Mongo-Kacheln als Router-Link, WP-Kacheln als echtes <a> mit Hinweispfeil
// (laden als WordPress-Seite), comingSoon deaktiviert.
//
// Schmal steht die Sidebar ueber dem Inhalt; dort klappt die Liste zu einem
// Knopf zusammen (Sichtbarkeit per CSS am Umbruch, eine einzige Liste im DOM).
const itemKey = (tile) => tile.slug || `wp-${tile.wpPageId}`

const Item = ({ tile, event, aktiv }) => {
    const klasse = `event-section-nav-item ${aktiv ? 'is-active' : ''}`
    const markierung = aktiv ? { 'aria-current': 'page' } : {}

    if ('comingSoon' === tile.state) {
        return <span className={`${klasse} is-disabled`} aria-disabled="true" {...markierung}>{tile.title}</span>
    }

    if (tile.url) {
        return (
            <a
                className={klasse}
                href={tile.url}
                target={tile.newTab ? '_blank' : undefined}
                rel={tile.newTab ? 'noreferrer' : undefined}
                {...markierung}
            >
                {tile.title} <span aria-hidden="true">↗</span>
                {tile.newTab && <VisuallyHidden>{LABELS.opensNewTab}</VisuallyHidden>}
            </a>
        )
    }

    return (
        <Link className={klasse} to={`/events/${event.slug}/${tile.slug}/`} {...markierung}>
            {tile.title}
        </Link>
    )
}

const EventSectionNav = ({ event, tiles, activeSlug }) => {
    const [offen, setOffen] = useState(false)
    const listId = useId()

    return (
        <nav className={`event-section-nav ${offen ? 'is-open' : ''}`} aria-label={LABELS.sectionNav}>
            <p className="event-section-nav-title" aria-hidden="true">{LABELS.sectionNav}</p>
            <button
                type="button"
                className="event-section-nav-toggle"
                aria-expanded={offen}
                aria-controls={listId}
                onClick={() => setOffen(!offen)}
            >
                {LABELS.sectionNavToggle}
            </button>
            <ul id={listId} className="event-section-nav-list">
                {tiles.map(tile => (
                    <li key={itemKey(tile)}>
                        <Item tile={tile} event={event} aktiv={tile.slug === activeSlug} />
                    </li>
                ))}
            </ul>
        </nav>
    )
}

export default EventSectionNav
